import { render } from "./Checkbox.vue?vue&type=template&id=0aaa0b30"
import script from "./Checkbox.vue?vue&type=script&lang=js"
export * from "./Checkbox.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/hub.disinfo.eu/releases/81973855/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__